import { IMemberClient } from "@wingspanhq/payments/dist/interfaces";
import {
  EmailVerificationStatus,
  IActivity,
  IGrowthSourceNames,
  INewUser
} from "@wingspanhq/users/dist/lib/interfaces";
import { getHasPendingEligibilityRequirements } from "../../Invoices/utils/setUp";
import { WSStore } from "../../store";
import { GrowthSourceNames } from "../../utils/growthAttribution";

export const getShouldForceToVerifyEmail = (
  user: INewUser,
  memberClients: IMemberClient[]
) => {
  const hasPendingEligibilityRequirements = getHasPendingEligibilityRequirements(
    memberClients
  );
  const isEmailVerified =
    user.emailVerificationState?.status === EmailVerificationStatus.Verified;
  return !isEmailVerified && hasPendingEligibilityRequirements;
};

export const getShouldForceToOnboard1099 = (activity?: IActivity) =>
  (activity?.context?.growthSource === IGrowthSourceNames.Enterprise ||
    activity?.context?.growthSource === IGrowthSourceNames.Collaborator) &&
  !activity?.flows.onboarding1099?.complete;

export const getShouldForceToEnablePayments = (activity?: IActivity) =>
  (activity?.context?.growthSource === IGrowthSourceNames.Enterprise ||
    activity?.context?.growthSource === IGrowthSourceNames.Collaborator) &&
  !activity?.flows.paymentsSetup?.complete;

export const getCurrentPartnerId = (store: WSStore) =>
  (store.growthAttributionDetails?.growthSource === GrowthSourceNames.Partner &&
    store.growthAttributionDetails?.growthName) ||
  "";

export const getCurrentEntepriseId = (store: WSStore, activity?: IActivity) =>
  (store.growthAttributionDetails?.growthSource ===
    GrowthSourceNames.Enterprise &&
    store.growthAttributionDetails?.growthName) ||
  activity?.context?.growthSourceName ||
  "";
